import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Image } from 'components/core/Image';
import TooltipBanner from '../../core/TooltipBanner/TooltipBanner';
import './TopBanner.scss';

const TopBanner = ({
	className,
	title,
	content,
	icon,
	tooltipMessage,
	tooltipIcon,
	iconAlt,
	type,
}) => (
	<div className={classnames('top-banner', type, className)}>
		{icon && (
			<Image
				src={icon}
				className="top-banner__icon"
				alt={iconAlt}
			/>
		)}
		<div className="top-banner__text">
			<span className="top-banner__title">{title}</span>
			<span className="top-banner__content">{content}</span>
		</div>
		{tooltipMessage && tooltipIcon && (
			<TooltipBanner
				className="tooltip"
				tooltipContent={tooltipMessage}
				tooltipIcon={
					<Image
						src={tooltipIcon}
						className="tooltip-icon"
						alt="tooltip icon"
					/>
				}
				hideTooltipForLarge={false}
				size="normal"
			></TooltipBanner>
		)}
	</div>
);

TopBanner.propTypes = {
	className: PropTypes.string,
	content: PropTypes.any,
	icon: PropTypes.string,
	title: PropTypes.string,
	iconAlt: PropTypes.string,
	tooltipIcon: PropTypes.string,
	tooltipMessage: PropTypes.string,
	type: PropTypes.oneOf(['general', 'promo', 'low-inventory']),
};

TopBanner.defaultProps = {
	className: '',
};

export default TopBanner;
